import { Input } from 'components/ui/input';
import { X } from 'lucide-react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

const CharacterDetailsMobile = ({ setOpen }: { setOpen: () => void }) => {
  // to get hosts and guests information
  const { hosts, guests } = useSelector((state: RootState) => state.podcastGen);
  
  // Custom styles for the input fields
  const inputStyles = "border-[1px] border-[rgba(0,20,13,0.16)] rounded-[8px] bg-white focus:ring-0 h-12 px-4";

  return (
    <>
      <div className="fixed inset-0 flex items-center justify-center bg-black/50">
        <div className="w-[95%] max-w-md h-fit-content overflow-y-auto py-6 bg-[#ebebeb] rounded-lg">
          <div className="flex justify-between px-4">
            <h2 className="text-[14px] text-[#000A07]/60 uppercase">
              Character Details
            </h2>
            <X size={16} color="#5F6563" onClick={setOpen} />
          </div>
          <div className="px-4">
            {/* host details */}
            <div className="mt-5 bg-[#ebebeb] rounded-lg">
              <div className="flex flex-col gap-4">
                {/* heading */}
                <div className="border-b-2 pb-4">
                  <h1 className="text-[24px] text-black font-semibold text-left">
                    Host details
                  </h1>
                </div>
                {/* detail heading */}
                {hosts.map((host, index) => (
                  <div className="space-y-3" key={index}>
                    <h2 className="text-[#846CEC] font-medium text-[12px]">
                      Host-{index + 1}
                    </h2>
                    <div
                      className="grid grid-rows-2 grid-cols-2 gap-2"
                      key={index}
                    >
                      {/* mapping of inputs */}
                      <div className="flex flex-col gap-2">
                        <label className="text-[#1C2024] text-[14px]">
                          Voice
                        </label>
                        <Input defaultValue={host?.voice_name || "Text"} disabled className={inputStyles} />
                      </div>
                      <div className="flex flex-col gap-2">
                        <label className="text-[#1C2024] text-[14px]">Name</label>
                        <Input defaultValue={host?.character_name || "Text"} disabled className={inputStyles} />
                      </div>
                      <div className="flex flex-col gap-2">
                        <label className="text-[#1C2024] text-[14px]">Age</label>
                        <Input defaultValue={host?.age || "Text"} disabled className={inputStyles} />
                      </div>
                      <div className="flex flex-col gap-2">
                        <label className="text-[#1C2024] text-[14px]">
                          Qualities
                        </label>
                        <Input defaultValue={host?.qualities?.length ? host.qualities.join(', ') : 'Text'} disabled className={inputStyles} />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {/* guest details */}
            <div className="mt-8 bg-[#ebebeb] rounded-lg">
              <div className="flex flex-col gap-4">
                {/* heading */}
                <div className="border-b-2 pb-4">
                  <h1 className="text-[24px] text-black font-semibold text-left">
                    Guest details
                  </h1>
                </div>
                {/* detail heading */}
                {guests.map((guest, index) => (
                  <div className="space-y-3" key={index}>
                    <h2 className="text-[#846CEC] font-medium text-[12px]">
                      Guest-{index + 1}
                    </h2>
                    <div
                      className="grid grid-rows-2 grid-cols-2 gap-2"
                      key={index}
                    >
                      {/* mapping of inputs */}
                      <div className="flex flex-col gap-2">
                        <label className="text-[#1C2024] text-[14px]">
                          Voice
                        </label>
                        <Input defaultValue={guest?.voice_name || "Text"} disabled className={inputStyles} />
                      </div>
                      <div className="flex flex-col gap-2">
                        <label className="text-[#1C2024] text-[14px]">Name</label>
                        <Input defaultValue={guest?.character_name || "Text"} disabled className={inputStyles} />
                      </div>
                      <div className="flex flex-col gap-2">
                        <label className="text-[#1C2024] text-[14px]">Age</label>
                        <Input defaultValue={guest?.age || "Text"} disabled className={inputStyles} />
                      </div>
                      <div className="flex flex-col gap-2">
                        <label className="text-[#1C2024] text-[14px]">
                          Qualities
                        </label>
                        <Input defaultValue={guest?.qualities?.length ? guest.qualities.join(', ') : 'Text'} disabled className={inputStyles} />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CharacterDetailsMobile;
